import React, { createContext, useState } from "react";

interface ChangeStatusActionContextType {
  element: any;
  setElement: (element: any) => void;
  elementId: any;
  setElementId: (elementId: any) => void;
  statusId: any;
  setStatusId: (statusId: any) => void;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;
}

export const ChangeStatusActionContext = createContext<ChangeStatusActionContextType>({
  elementId: null,
  setElementId: () => {},
  element: null,
  setElement: () => {},
  statusId: null,
  setStatusId: () => {},
  showModal: false,
  setShowModal: () => {},
  backendFormErrors: {},
  setBackendFormErrors: () => {},
});

interface ChangeStatusActionProviderProps {
  children: React.ReactNode;
}

export const ChangeStatusActionProvider: React.FC<ChangeStatusActionProviderProps> = ({
  children,
}) => {
  const [elementId, setElementId] = useState<any>(null);
  const [statusId, setStatusId] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [element, setElement] = useState<any>(null);

  const value = {
    elementId,
    setElementId,
    statusId,
    setStatusId,
    showModal,
    setShowModal,    
    backendFormErrors,
    setBackendFormErrors,
    element,
    setElement,
  };
  return (
    <ChangeStatusActionContext.Provider value={value}>
      {children}
    </ChangeStatusActionContext.Provider>
  );
};
